module.exports = __webpack_public_path__ + "static/media/gallery-3.e5c6ecc3.jpg";